import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  REACT_APP_MONNIFY_API_KEY: Yup.string().required(
    "Please provide a MONNIFY API Key",
  ),
  REACT_APP_MONNIFY_CONTRACT_CODE: Yup.string().required(
    "Please provide a MONNIFY contract code",
  ),
  REACT_APP_API_BASE_URL: Yup.string().required(
    "Please provide aN API base url",
  ),
});

const env = validationSchema.validateSync(process.env);

export default env;
